import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from "@angular/router";
import { UserService } from "@app/services/user.service";
import { Observable, from, of } from "rxjs";
import { catchError, map, tap } from "rxjs/operators";

@Injectable({
  providedIn: "root", // Angular's tree-shakable providers
})
export class WelcomeGuardService {
  constructor(private userService: UserService, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return from(this.userService.hasBusinessInformation()).pipe(
      tap((hasBusinessInformation) => {
        if (!hasBusinessInformation) {
          this.router.navigate(["/welcome"]);
        }
      }),
      map((hasBusinessInformation) => hasBusinessInformation),
      // Fail closed: a failed /me must not leave the navigation pending, which
      // renders as a blank page with no redirect.
      catchError((error) => {
        console.error("WelcomeGuardService: profile lookup failed", error);
        this.router.navigate(["/"]);
        return of(false);
      })
    );
  }

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.canActivate(route, state);
  }
}
